import React from 'react'
import ReactDOM from 'react-dom'

export default class PackageSize extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.selectSize = this.selectSize.bind(this)
  }

  selectSize(size){
    this.props.selectSize(size)
  }

  render() {
    var active = this.props.size == this.props.dimension.label ? "dimension active" : "dimension"
    var dimensions = this.props.dimension.height + 'x' + this.props.dimension.width + 'x' + this.props.dimension.length + 'cm'
    var details = I18n.t('dimensions.details') + ' ' + dimensions
    var label = "dimensions." + this.props.dimension.label + ".label"
    var image = sizes[this.props.dimension.label]
    return (
      <div className="col-4 col-sm-4 offset-sm-0 p-1" onClick={() => this.selectSize(this.props.dimension.label)}>
        <label className={active} value={this.props.size} >
          <span className="label">{I18n.t(label)}</span>
          <img src={image} alt={this.props.dimension.label} />
          <span className="details">
            {details}
          </span>
        </label>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/PackageSize.jsx